import { render } from "./Fixed.vue?vue&type=template&id=ead69332&scoped=true"
import script from "./Fixed.vue?vue&type=script&lang=js"
export * from "./Fixed.vue?vue&type=script&lang=js"

import "./Fixed.vue?vue&type=style&index=0&id=ead69332&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ead69332"]])

export default __exports__